import { Injectable } from '@angular/core';

import { UserResponse } from '@dav-model/login/response/user.response.model';
import { AggregatorRequest } from '@dav-model/request/aggregator.request';
import { GetProductsRequest } from '@dav-model/request/product.request';
import { GetProductsResponse, ProductItem } from '@dav-model/response/getproducts.response';

import { CartValidationService } from '../validations/cart/cart.validation';

@Injectable({
  providedIn: 'root',
})
export class ProductService {
  static productResponseDataMapper(products: ProductItem[]): ProductItem[] {
    return products.map((product) => {
      const updatedProduct = { ...product, customerTerm: +product.maxTerm, errorFlag: false, errorMessage: '' };

      return CartValidationService.calculateGrid(updatedProduct);
    });
  }

  static aggregateProductRequestMapper(request: GetProductsRequest): AggregatorRequest {
    const req = new AggregatorRequest(request);

    // validate languageCode
    if (!req.languageCode) {
      req.languageCode = '';
    }
    // CS 3.1 issue, this should be temporary until 3.1 is fixed.
    req.languageCode = '';

    // skipping any surchage modifications (this will be after the getproducts call)

    // validate inservice date
    if (!req.inServiceDate) {
      req.inServiceDate = '';
    }

    return req;
  }

  static assignPropertiesToProducts(response: GetProductsResponse, user: UserResponse): GetProductsResponse {
    response.availableOptions.products.productItem.forEach((data) => {
      // Assigning category to each product
      if (user.productCategory) {
        data.productCategory = user.productCategory[data.productCode];
      }

      // Assigning vendor to each product if isRelatedDealer exists
      if (user.isRelatedDealer) {
        const index = user.allDealers.findIndex((dealer) => dealer.cmsDealerNumber === data.dealer);
        if (index > -1) {
          data.vendor = user.allDealers[index].vendor;
        }
      }
    });

    return response;
  }

  static prepProductsForSurcharges(request: GetProductsRequest, response: GetProductsResponse): GetProductsResponse {
    const surcharges = request.yamahaSurcharges;

    if (!surcharges) {
      return response;
    }

    response.availableOptions.products.productItem.forEach((productItem: ProductItem) => {
      productItem.surchargeOptions.surchargeOption.forEach((option) => {
        option.added = false;
      });
      productItem.surchargeAdded = false;
    });

    return response;
  }
}
